<template>
  <div class="o-loader" :class="['o-loader--' + color]">
    <div class="o-loader__group">
      <span class="o-loader--1"></span>
      <span class="o-loader--2"></span>
    </div>
    <div class="o-loader__group">
      <span class="o-loader--3"></span>
      <span class="o-loader--4"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ObjectLoader",
  props: {
    color: String,
  },
};
</script>
